<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="12" lg="6">
                <!-- brockerActionTypes -->
                <el-text-field
                  label="VAR ID"
                  v-model="mainData['var_id-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                <el-text-field
                  label="Naudotojo vardas"
                  v-model="mainData['user_name-search-like']"
                  hide-details
                  :maxlength="20"
                />
              </v-col>
              <v-col cols="12" md="12" lg="6">
                 <el-autocomplete
                  :items="enumsClassifiers.brockerActionTypes"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Paslauga"
                  v-model="mainData['action-search-like']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-date-picker
                  label="Data nuo"
                  v-model="mainData['created_at-search-from']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-date-picker
                  label="Data iki"
                  v-model="mainData['created_at-search-to']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="broker-logs" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminDataSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.enumsClassifiers = Enums
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      if (
        this.searchParams &&
        this.searchParams.filter == 'data' &&
        this.searchParams.route === this.$route.name
      ) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData() {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        filter: 'data',
      })
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = { isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData()
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData()
        } 
      })
    },
  },
}
</script>
